// relative
import { apiSlice } from "../../apiSlice"

export const baselineApiSlice = apiSlice.injectEndpoints({
    tagTypes: ['Baseline'],
    endpoints: builder => ({
        getBaselineDaysById: builder.query({
            query: (args) => {
                const {subscriptionId, from} = args
                return {
                    url: `/JobSubscription/${subscriptionId}/BaselineDays?orderby=Start&Start=ge(${from})&top=10000`,
                    providesTags: ['Baseline'],
                }
            }
        })
    })
})

export const {
    useLazyGetBaselineDaysByIdQuery,
    useGetBaselineDaysByIdQuery,
} = baselineApiSlice

